"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Убрать повторяющиеся объекты из списка
 * @param objectList - список объектов
 * @param key - ключ к параметру
 */
function removeDuplicateByKey(objectList, key) {
    var list = [];
    var _loop_1 = function (objectItem) {
        // @ts-ignore
        if (list.findIndex(function (item) { return item[key] === objectItem[key]; }) === -1) {
            list.push(objectItem);
        }
    };
    for (var _i = 0, objectList_1 = objectList; _i < objectList_1.length; _i++) {
        var objectItem = objectList_1[_i];
        _loop_1(objectItem);
    }
    return list;
}
exports.removeDuplicateByKey = removeDuplicateByKey;
//# sourceMappingURL=removeDuplicateByKey.js.map